import { render, staticRenderFns } from "./QuestionTable.vue?vue&type=template&id=23a3bef8&scoped=true&"
import script from "./QuestionTable.vue?vue&type=script&lang=js&"
export * from "./QuestionTable.vue?vue&type=script&lang=js&"
import style0 from "./QuestionTable.vue?vue&type=style&index=0&id=23a3bef8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a3bef8",
  null
  
)

export default component.exports